import { createContext, useContext } from 'react';

export interface DraggableRowContextValue {
  isDragOverlay?: boolean;
}

export const DraggableRowContext = createContext<DraggableRowContextValue>({});
export const useDraggableRowContext = () => useContext(DraggableRowContext);
